var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSymbolMono = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 354 400"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#2B323F",
  d: "M325.663 145.139H28.318C12.678 145.139 0 157.818 0 173.459v53.101c0 15.641 12.679 28.321 28.319 28.321h297.344c15.64 0 28.318-12.68 28.318-28.321v-53.101c0-15.641-12.678-28.32-28.318-28.32"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#symbol-mono_svg__a)",
  d: "M283.327 91.966 21.133 240.365C11.699 245.711 0 238.896 0 228.046v-72.678a56.66 56.66 0 0 1 28.708-49.277L202.867 7.376c27.221-15.435 61.805-5.859 77.221 21.382l13.929 24.621c7.699 13.612 2.903 30.887-10.69 38.587"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#symbol-mono_svg__b)",
  d: "m70.655 308.052 262.194-148.417c9.433-5.345 21.133 1.469 21.133 12.32v72.677a56.67 56.67 0 0 1-28.708 49.278l-174.159 98.715c-27.221 15.434-61.805 5.858-77.221-21.382l-13.93-24.622c-7.698-13.611-2.902-30.887 10.69-38.586z"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "symbol-mono_svg__a",
  x1: 0,
  x2: 305.553,
  y1: 242.225,
  y2: 84.222,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#757D86"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#2B323F"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "symbol-mono_svg__b",
  x1: 353.982,
  x2: 48.485,
  y1: 164.741,
  y2: 321.588,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#DBDEE1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#757D86"
})))));
export default SvgSymbolMono;